import React from 'react';
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";



function footerLap() {
  return (
    <div className="footer">
      <MDBFooter color="green" className="font-small pt-4 mt-4">
      <MDBContainer fluid className="text-center text-md-left">
        <MDBRow>
          <MDBCol >
            <h5 className="title" style={{textAlign:'center'}}>Tech utilisé : Typescript & React</h5>
            </MDBCol>
          </MDBRow>
          <MDBRow>
          <MDBCol>
            <h5 className="title" style={{textAlign:'center'}}>2021-2022</h5>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <div className="footer-copyright text-center py-3">
        <MDBContainer fluid>
          &copy; {new Date().getFullYear()} Copyright: Mitton Benjamin 
        </MDBContainer>
      </div>
    </MDBFooter>
    </div>
  );
}

export default footerLap;
